import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { FileUpload } from '../shared/FileUpload'

export class ProfileSelector extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            isDirty: false,
            profileImage: props.profileImage,
            file: null
        };
        this.handleOpenModal = this.handleOpenModal.bind(this);
        this.handleCloseModal = this.handleCloseModal.bind(this);
        this.handleRemoveImage = this.handleRemoveImage.bind(this);
        this.handleNewImage = this.handleNewImage.bind(this);
        this.handleSaveImage = this.handleSaveImage.bind(this);
    }

    handleOpenModal() {
        this.setState({ modal: true });
    }

    handleCloseModal() {
        this.setState({
            modal: false,
            isDirty: false,
            profileImage: this.props.profileImage,
            file: null
        });
    }

    handleRemoveImage() {
        this.setState({ profileImage: 'profile_image_empty.png', isDirty: true, file: null });
    }

    handleNewImage(file) {
        this.setState({ profileImage: window.URL.createObjectURL(file), file: file, isDirty: true });
    }

    handleSaveImage() {
        if (!this.state.isDirty) {
            console.log("Cannot save a file if it doesn't exist.")
            return;
        }
        this.props.handleImageChanged(this.state.file);
        this.setState({ isDirty: false })
    }

    render() {
        return (
          <div className="container margin-top-10">
                <Button onClick={this.handleOpenModal} title="Change picture button">Change Picture</Button>
            <Modal isOpen={this.state.modal} toggle={this.handleCloseModal} className={this.props.className} >
              <ModalHeader className="k-content" toggle={this.handleCloseModal}>Change your Profile Picture</ModalHeader>
                <ModalBody className="k-content">
                  <div className="container">
                      <div className="row">
                          <div className="col">
                              <div className="row">
                                  <FileUpload
                                      accept="image/jpg,image/jpeg,image/gif,image/png"
                                      handleChangeFile={this.handleNewImage}
                                  />
                              </div>
                              <div className="row margin-top-10">
                                  <Button onClick={this.handleRemoveImage}>Remove Image</Button>
                              </div>
                          </div>
                          <div className="col">
                              <img src={this.state.profileImage}
                                  alt={this.state.profileImage === 'profile_image_empty.png'
                                      ? 'Default Avatar'
                                      : 'Avatar for ' + this.props.employee.firstName + ' ' + this.props.employee.lastName}
                                  className="w-75" tabIndex="0" />
                          </div>
                      </div>
                  </div>
                </ModalBody>
                <ModalFooter className="k-content">
                  <Button color="primary" disabled={!this.state.isDirty} onClick={this.handleSaveImage}>Save</Button>{' '}
                  <Button color="secondary" onClick={this.handleCloseModal}>Cancel</Button>
                </ModalFooter>
              </Modal>
            </div>
        );
    }
}
